import { Drawer, Space } from 'antd';
import { getRouteStore } from 'core/modules/routes/route.store';
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { RouteDirectionsMapView } from './DirectionsMap';
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export var RouteDrawer = function RouteDrawer(_ref) {
  var _route$routes;

  var isVisible = _ref.isVisible,
      routeId = _ref.routeId,
      onClose = _ref.onClose;

  var _useState = useState(),
      route = _useState[0],
      setRoute = _useState[1];

  var _getRouteStore = getRouteStore(),
      routeById = _getRouteStore.routeById;

  useEffect(function () {
    if (routeById(routeId)) {
      setRoute(routeById(routeId));
    }
  }, [routeById, routeId]);
  return /*#__PURE__*/_jsx(Container, {
    open: isVisible,
    width: 600,
    onClose: onClose,
    children: route && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsxs(Space, {
        direction: "vertical",
        children: [route.status, route.date, route.title, route.notes]
      }), /*#__PURE__*/_jsx(RouteDirectionsMapView, {
        plan: route.route.raw
      }), (_route$routes = route.routes) === null || _route$routes === void 0 ? void 0 : _route$routes.map(function (it) {
        return /*#__PURE__*/_jsx(_Fragment, {
          children: /*#__PURE__*/_jsx(RouteDirectionsMapView, {
            plan: it.raw
          })
        });
      })]
    })
  });
}; // Styles

var Container = styled(Drawer).withConfig({
  displayName: "Drawer__Container",
  componentId: "sc-jygpzo-0"
})([""]);